 const HAMSTER_LPADDR = '0xfa7e034dc83a50b67b4a0b421eb6a926a13b685f'

 const VHAMSTER_LPADDR = '0xF7145aE0B1c1F1785c7e8101F29f08112f3D5f6A'

 const HAMSTER_PLEDGE_ADDR = '0x4806937fC21DD99E4607ebfFc8e406965523A38F'

 export  { HAMSTER_LPADDR, HAMSTER_PLEDGE_ADDR ,VHAMSTER_LPADDR}